import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Users, Lightbulb, Truck, Sprout } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Extension Services',
  description: 'Providing advisory services to farmers on modern farming techniques.',
  icon: Users
}, {
  title: 'Technology Transfer',
  description: 'Facilitating the adoption of improved agricultural technologies.',
  icon: Lightbulb
}, {
  title: 'Farmer Group Formation',
  description: 'Organizing farmers into groups for better resource access and marketing.',
  icon: Users
}, {
  title: 'Input Distribution',
  description: 'Distributing seeds, seedlings, and breeding stock to farmers.',
  icon: Truck
}];
export function NaadsPage() {
  return <>
      <Header data-id="element-1163" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1164">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1165">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1592982537447-6f2a6a0c7c18?w=1600&h=600&fit=crop")'
        }} data-id="element-1166"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1167"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1168">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1169">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1170">
                <Home className="w-4 h-4 mr-1" data-id="element-1171" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1172" />
              <span data-id="element-1173">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1174" />
              <span className="text-white font-medium" data-id="element-1175">NAADS</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1176">NAADS</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1177">
              National Agricultural Advisory Services.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-1178">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-1179">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1180">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1181">
              To increase agricultural productivity and profitability through
              the provision of effective and efficient agricultural advisory
              services and technologies to farmers.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-1182">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1183">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1184">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-1185">
                    <Icon className="w-6 h-6" data-id="element-1186" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-1187">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1188">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-1189" />
    </>;
}